import React from "react";
import { BsGithub } from "react-icons/bs";
import { FaGlobe } from "react-icons/fa";

const ProjectsCard = ({ title, des, src, github, live, stack }) => {
  return (
    <div className="w-full h-full p-4 xl:p-6 rounded-2xl glass-panel flex flex-col group transition-all duration-500">
      <div
        className="relative w-full rounded-xl ring-1 ring-white/10 flex items-center justify-center overflow-hidden"
        style={{
          aspectRatio: "16 / 10",
          background:
            "radial-gradient(circle at 50% 40%, rgba(30,41,59,0.95) 0%, rgba(2,6,23,1) 70%)",
          padding: src ? "10px" : "16px",
        }}
      >
        {src ? (
          <img
            className="w-full h-full object-contain object-center rounded-lg group-hover:scale-[1.02] duration-500 cursor-pointer"
            src={src}
            alt={`${title} preview`}
            style={{ maxWidth: "100%", maxHeight: "100%" }}
          />
        ) : (
          <div className="flex flex-col items-center justify-center text-center gap-2 px-4">
            <p className="text-lg md:text-xl font-titleFont font-bold text-slate-100">
              {title}
            </p>
            {stack && (
              <p className="text-xs font-mono text-cyan-300/90 leading-relaxed">
                {stack}
              </p>
            )}
          </div>
        )}
      </div>

      <div className="w-full mt-5 flex flex-col flex-1 gap-3">
        <div className="flex items-start justify-between gap-3 min-h-[3rem]">
          <div className="min-w-0">
            <h3 className="text-sm uppercase text-cyan-300 font-mono font-normal tracking-wide leading-snug">
              {title}
            </h3>
            {stack && src && (
              <p className="text-[11px] font-mono text-slate-500 mt-1 leading-snug">
                {stack}
              </p>
            )}
          </div>
          <div className="flex gap-2 shrink-0">
            {github && (
              <a
                href={github}
                target="_blank"
                rel="noopener noreferrer"
                className="text-lg w-9 h-9 rounded-full bg-slate-950/70 border border-white/10 inline-flex justify-center items-center text-slate-400 hover:text-cyan-300 hover:border-cyan-400/40 duration-300 cursor-pointer"
                aria-label={`${title} GitHub`}
              >
                <BsGithub />
              </a>
            )}
            {live && (
              <a
                href={live}
                target="_blank"
                rel="noopener noreferrer"
                className="text-lg w-9 h-9 rounded-full bg-slate-950/70 border border-white/10 inline-flex justify-center items-center text-slate-400 hover:text-cyan-300 hover:border-cyan-400/40 duration-300 cursor-pointer"
                aria-label={`${title} live site`}
              >
                <FaGlobe />
              </a>
            )}
          </div>
        </div>
        <p className="text-sm tracking-wide text-slate-400 group-hover:text-slate-200 duration-300">
          {des}
        </p>
      </div>
    </div>
  );
};

export default ProjectsCard;
